module.exports = __webpack_public_path__ + "1848580c85dd90343103dd439986f9b0.png";